<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.804 20.001 20.472 4M9.333 18.268c.863.27 1.763.404 2.667.4 3.645.062 7.343-2.498 9.618-5.014a1.467 1.467 0 0 0 0-1.973 17.832 17.832 0 0 0-2.729-2.454M16.525 7.796A10.054 10.054 0 0 0 12 6.666c-3.556-.061-7.29 2.446-9.618 5.015a1.467 1.467 0 0 0 0 1.973 17.781 17.781 0 0 0 4.382 3.556"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.334 14.73a3.423 3.423 0 0 1 4.889-4.694M15.334 12.667A3.333 3.333 0 0 1 12 16.001"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
